import { render, staticRenderFns } from "./LeaveWasCancelled.vue?vue&type=template&id=74aeb0ba"
import script from "./LeaveWasCancelled.vue?vue&type=script&lang=js"
export * from "./LeaveWasCancelled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports